export * from '@lskjs/err';
export { default } from '@lskjs/err';
